import { IEntityManagerProps, IEntityManagerStates } from "../../components/entityManager/interfaces";
import { IEntity } from "../../components/infrastructure/models";
import { IInsurer } from "../insurer/interfaces";
import { IInsurerCenter } from "../insurerCenter/interfaces";

export enum enmInsurerCenterPersonnelTypes {
    Admin = 0,
    DamageExpert1 = 1,
    DamageExpert2 = 2,
    DamageExpert3 = 3,
    DamageExpert4 = 4
}

export interface IInsurerCenterPersonnel extends IEntity {
    InsurerId: number;
    Insurer: IInsurer;
    InsurerCenterId?: number;
    InsurerCenter?: IInsurerCenter;
    Type: enmInsurerCenterPersonnelTypes;
    FullName: string;
}

export interface IInsurerCenterPersonnelProps extends IEntityManagerProps<IInsurerCenterPersonnel> {
    params?: () => { insurerCenter?: IInsurerCenter; };
}

export interface IInsurerCenterPersonnelStates extends IEntityManagerStates<IInsurerCenterPersonnel> {

}
